import React, { useContext } from 'react'
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import { getSupportingDoc } from '../../../utils';
import { UserDetails } from 'appContext';
import { useWizard } from 'components/wizard/WizardContext';
import { failureToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';
const DownloadSupportingDoc = ({
    isDisabled,
    isSelected,
    refundDetailsForm,
    refundSubType,
    isLoanCase,
    setLoading
}) => {
    const { values, dropdowns, next, current } = useWizard();
    const { multiTypeRefundStep2Data, selectedStudent } = values;
    const { additionalStudentDetails } = multiTypeRefundStep2Data;
    const studentDetails = {
        ...selectedStudent,
        ...additionalStudentDetails
    }
    const { reason, payableToParent, payableToVendor } = refundDetailsForm?.[refundSubType] || {}

    const isFilled = (v) => v !== null && v !== undefined;

    const isRequiredFieldFilled =
        reason &&
        isFilled(payableToParent) &&
        (!isLoanCase || isFilled(payableToVendor));


    const { businessAres } = dropdowns?.data || {}

    const useDetails = useContext(UserDetails)

    const backToPrevStep = () => next(0);

    const downloadSupportingDoc = async () => {
        const { studentAccountDetails } = studentDetails
        const primaryBankAccountDetails = studentAccountDetails ? studentAccountDetails.find(item => (item?.accountType == "Primary" && item?.bankStatus == "ACTIVE")) : null
        if (!primaryBankAccountDetails) {
            failureToast("Please add an active primary bank account.")
            backToPrevStep();
            return;
        }

        getSupportingDoc(useDetails, studentDetails, businessAres, refundDetailsForm, refundSubType, isLoanCase, setLoading)
    }
    return (
        current == 1 && (<AButton
            variant='outline'
            size='xs'
            disabled={isDisabled || !isSelected || !isRequiredFieldFilled}
            onClick={(e) => {
                e.stopPropagation();
                downloadSupportingDoc()
            }}
        >
            Download consent form
        </AButton>)
    )
}
export default DownloadSupportingDoc;